// Topics reducer types
export const GET_TOPICS = 'GET_TOPICS';
export const GET_TOPIC = 'GET_TOPIC';
export const POST_TOPIC = 'POST_TOPIC';
export const JOIN_TOPIC = 'JOIN_TOPIC';
export const LEAVE_TOPIC = 'LEAVE_TOPIC';
export const DELETE_TOPIC = 'DELETE_TOPIC';
export const LIKE_TOPIC = 'LIKE_TOPIC';
export const UNLIKE_TOPIC = 'UNLIKE_TOPIC';
export const SUBMIT_COMMENT = 'SUBMIT_COMMENT';
export const INVITE_FOR_TOPIC = 'INVITE_FOR_TOPIC';
export const REMOVE_INVITE = 'REMOVE_INVITE';
export const EDIT_TOPIC = 'EDIT_TOPIC';

export type Topic = {
  _id: string;
  title: string;
  branch: string;
  description: string;
  owner: any;
  isPrivate: boolean;
  bannerImage: string;
  category: string;
  subject: string;
  members: Array<any>;
  resources: Array<any>;
  posts: Array<any>;
};
